/**
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const kernel = require('../kernel/kernel')
const CMarqueAngleAncetre = require('./CMarqueAngleAncetre')
module.exports = CMarqueAngleDroit

/**
 * Classe représentant une marque d'angle droit.
 * @constructor
 * @extends CMarqueAngleAncetre
 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
 * @param {Boolean} estElementFinal : true si élément final de construction.
 * @param {mtg32.Color} couleur : La couleur.
 * @param {Boolean} masque : true si l'objet est masqué.
 * @param {mtg32.StleTrait} style : Donne le style trait utilisé.
 * @param {StyleMarqueAngle} styleMarque : Donne le style de la marque.
 * @param {Float} rayon : Le rayon de l'arc.
 * @param {CDroitePerpendiculaire} perp : La droite perpendiculaire
 * associée.
 * @returns {CMarqueAngleDroit}
 */
function CMarqueAngleDroit (listeProprietaire, impProto, estElementFinal, couleur, masque,
    style, styleMarque, rayon, perp){
  if (arguments.length === 1) CMarqueAngleAncetre.call(this, listeProprietaire);
  else {
    CMarqueAngleAncetre.call(this, listeProprietaire, impProto, estElementFinal, couleur,
      masque, style, styleMarque, rayon);
    this.perp = perp;
  }
}
CMarqueAngleDroit.prototype = new CMarqueAngleAncetre();
CMarqueAngleDroit.prototype.constructor = CMarqueAngleDroit;
CMarqueAngleDroit.prototype.superClass = "CMarqueAngleAncetre";
CMarqueAngleDroit.prototype.className = "CMarqueAngleDroit";

CMarqueAngleDroit.prototype.getClone = function(listeSource, listeCible) {
  var ind1 = listeSource.indexOf(this.perp);
  var ind2 = listeSource.indexOf(this.impProto);
  return new CMarqueAngleDroit(listeCible, listeCible.get(ind2, "CImplementationProto"),
    this.estElementFinal, this.couleur, this.masque, this.style.getClone(), this.styleMarque, this.rayon,
    listeCible.get(ind1, "CDroitePerpendiculaire"));
};
CMarqueAngleDroit.prototype.ajouteAntecedents = function(liste) {
  liste.add(this.perp);
};
CMarqueAngleDroit.prototype.depDe = function(p) {
  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
  return this.memDep(CMarqueAngleAncetre.prototype.depDe.call(this, p) || this.perp.depDe(p));
};
CMarqueAngleDroit.prototype.dependDePourBoucle = function(p) {
  return ((p === this) || this.perp.dependDePourBoucle(p));
};
CMarqueAngleDroit.prototype.positionne = function(infoRandom, dimfen) {
  this.existe = this.perp.existe;
  if (!this.existe) return;
  var intersection= {};
  kernel.intersectionDroitesSecantes(this.perp.a.x,this.perp.a.y,this.perp.vect,
    this.perp.d.point_x,this.perp.d.point_y,this.perp.d.vect,intersection);
  this.centre_x = intersection.x;
  this.centre_y = intersection.y;
  this.perp.vect.setCopy(this.u);
  this.perp.d.vect.setCopy(this.v);
  this.ang1rad = this.u.angleRad();
  this.ang2rad = this.v.angleRad();
  this.prepareAngleDroit();
  CMarqueAngleAncetre.prototype.positionne.call(this, infoRandom, dimfen);
};
CMarqueAngleDroit.prototype.createg = function(svg,couleurFond,transparence){
  return CMarqueAngleAncetre.prototype.creategAngleDroit.call(this,transparence);
};
CMarqueAngleDroit.prototype.update = function(svg,couleurFond,transparence) {
  var oldg = this.g;
  var g = this.createg(svg,couleurFond,transparence);
  svg.replaceChild(g, oldg);
  g.setAttribute("id",this.id);
  this.g = g;
};
CMarqueAngleDroit.prototype.confonduAvec = function(p) {
  if (p.className === this.className) return (this.perp === p.perp);
  else return false;
};
CMarqueAngleDroit.prototype.read = function(inps, list){
  CMarqueAngleAncetre.prototype.read.call(this, inps, list);
  var ind1 = inps.readInt();
  this.perp = list.get(ind1,"CDroitePerpendiculaire");
};
CMarqueAngleDroit.prototype.write = function(oups, list){
  CMarqueAngleAncetre.prototype.write.call(this, oups, list);
  var ind1 = list.indexOf(this.perp);
  oups.writeInt(ind1);
};
